import { Autocomplete as BaseAutocomplete } from '@base-ui/react/autocomplete';
import { Input } from '@/components/ui/Input';

export interface AutocompleteProps {
  className?: string;
  items: string[];
  onValueChange: (value: string) => void;
  placeholder?: string;
  size?: 'sm' | 'md';
  value: string;
}

export const Autocomplete = ({
  className,
  items,
  onValueChange,
  placeholder,
  size = 'sm',
  value,
}: AutocompleteProps) => (
  <BaseAutocomplete.Root
    items={items}
    mode="list"
    onValueChange={(next) => onValueChange(next)}
    value={value}
  >
    <BaseAutocomplete.Input
      placeholder={placeholder}
      render={<Input className={className} size={size} />}
    />
    <BaseAutocomplete.Portal>
      <BaseAutocomplete.Positioner sideOffset={4}>
        <BaseAutocomplete.Popup className="z-40 w-(--anchor-width) max-w-(--available-width) rounded-md border border-border bg-surface p-1 shadow-md">
          <BaseAutocomplete.List className="max-h-[min(15rem,var(--available-height))] overflow-y-auto overscroll-contain">
            {items.map((item) => (
              <BaseAutocomplete.Item
                className="flex cursor-default items-center rounded-sm px-2 py-1 text-sm lg:text-base data-highlighted:bg-accent-soft data-highlighted:text-accent"
                key={item}
                value={item}
              >
                {item}
              </BaseAutocomplete.Item>
            ))}
            <BaseAutocomplete.Empty className="px-2 py-1 text-xs lg:text-sm text-foreground-muted">
              No matches
            </BaseAutocomplete.Empty>
          </BaseAutocomplete.List>
        </BaseAutocomplete.Popup>
      </BaseAutocomplete.Positioner>
    </BaseAutocomplete.Portal>
  </BaseAutocomplete.Root>
);
